//#region src/Calendar/utils.ts
const SELECTOR = "[data-reka-calendar-cell-trigger]:not([data-outside-view]):not([data-outside-visible-view])";
function getSelectableCells(calendar) {
	return Array.from(calendar.querySelectorAll(SELECTOR)) ?? [];
}

//#endregion
export { getSelectableCells };
//# sourceMappingURL=utils.js.map